import state from './moduleReferalState.js'
import mutations from './moduleReferalMutations.js'
import actions from './moduleReferalActions.js'
import getters from './moduleReferalGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
